module.exports = {
    "baseUrl": "https://api-v4.iris-health.com",
    "systemName": "System Prod",
    "favicon": "%PUBLIC_URL%/iris-health-logo.jpeg",
    "companyTitle": "Payment Portal | Iris Health",
    "companyKey": "iris",
    "website": "https://iris-health.com/",
    "cdnUrl": "https://cdn.iris-health.com",
    "companyName": "Iris Health",
    "copyRight": "Iris Health is a trademark of its respective owner.",
    "phoneNumber": "(469) 680-1248",
    "isChatBotEnabled": false
}